import React, { useState } from 'react';

import { Container, TabContainer, Label, Icon } from './styles';

interface PropsTab {
  label: string;
  isActive?: boolean;
  value?: string;
  icon?: JSX.Element;
  testId?: string;
  onClick: (value) => void;
}

const Tab = ({ label, isActive = false, icon, value, onClick, testId }: PropsTab) => (
  <TabContainer $active={isActive} onClick={() => onClick(value ?? label)} data-testid={testId}>
    {icon && <Icon>{icon}</Icon>}
    <Label>{label}</Label>
  </TabContainer>
);

export interface TabData {
  label: string;
  value?: string;
  icon?: JSX.Element;
  testId?: string;
  onClick?: (value) => void;
}

export interface Props {
  options: TabData[];
  current?: number;
}

const DesktopSearchBarTabs = ({ options, current = 0 }: Props) => {
  const [active, setActive] = useState(current);

  return (
    <Container>
      {options &&
        options.map((opt, k) => (
          <Tab
            key={k}
            label={opt.label}
            value={opt.value}
            icon={opt.icon}
            onClick={(value) => {
              setActive(k);
              if (opt.onClick) opt.onClick(value);
            }}
            isActive={active === k}
            testId={opt.testId}
          />
        ))}
    </Container>
  );
};

export default DesktopSearchBarTabs;
